import CustomAssetManager from "@/components/MediaLibrary/MediaLibrary";
import { Box, Grid, PageTitle, Row } from "@talentech/components";

const MediaLibraryPage = () => {
  return (
    <>
      <PageTitle title="Media library" />
      <Grid container spacing={3} className="mt-4">
        <Row>
          <Grid  xs={12}>
            <Box paper rounded spacing={4}>
              <CustomAssetManager onSelect={() => {}} />
            </Box>
          </Grid>
        </Row>
      </Grid>
    </>
  );
};
export default MediaLibraryPage;
